import state from './state'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const starMap = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}

export default starMap
